module.exports = new __parcel__URL__("gestural-line.8591d4ac.svg").toString();